const LOCAL_PHONE_LENGTH = 9;

export function normalizeUzPhoneInput(value?: string) {
	if (!value) {
		return "";
	}

	const digits = value.replace(/\D/g, "");
	const localDigits = digits.startsWith("998") ? digits.slice(3) : digits;

	return localDigits.slice(0, LOCAL_PHONE_LENGTH);
}

export function formatUzPhoneInput(value?: string) {
	const digits = normalizeUzPhoneInput(value);
	const parts = [
		digits.slice(0, 2),
		digits.slice(2, 5),
		digits.slice(5, 7),
		digits.slice(7, 9),
	].filter(Boolean);

	return parts.join(" ");
}

export function toUzPhoneE164(value?: string) {
	const digits = normalizeUzPhoneInput(value);

	if (digits.length !== LOCAL_PHONE_LENGTH) {
		return null;
	}

	return `+998${digits}`;
}
